import React from "react";
import Button from "../../atoms/button/button";
import "./buttonAuthHead.scss";
import GlobalContext from "../../../contexts/globalContext";


interface BtnAuthHeadInterface {
   text:string;
   href:string;
   validateAuth:boolean;
   className: string;
   gtmMark?:string;
   strictCss?: boolean;
}

const ButtonAuthHead = (props: BtnAuthHeadInterface) => {

   const { text, href, validateAuth, gtmMark, className, strictCss } = props;

   return (
      <GlobalContext.Consumer> 
         { data=>(
            <>
               { validateAuth && data.gigyaContext.gigyaAccount ? (
                  <Button
                     type="link"
                     text= { text }
                     classname= { className }
                     href= { href }
                     target="_blank"
                     isDisabled={false}
                     gtmMark = {gtmMark}
                     strictCss = {strictCss}
                  />
               ):(
                  <Button
                     type="button"
                     text= { text }
                     classname= { className }
                     onClickAction={ data.gigyaContext.login }
                     target="_blank"
                     isDisabled={false}
                     gtmMark = {gtmMark}
                     strictCss = {strictCss}
                  />
               )}
            </>
         )}
      </GlobalContext.Consumer>
   );
};

export default ButtonAuthHead;
